// src/components/layout/SideNav.js
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LibraryBig, LineChart, MessageSquare, Target, DatabaseZap, Waypoints} from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import Button from '../ui/Button';
import Progress from '../ui/Progress';

function SideNav() {
	
	const menuList = [
		{
			id: 1,
			name: 'Dashboard',
			icon: LibraryBig,
			path: '/dashboard'
		},
		{
			id: 2,
			name: 'Quotas',
			icon: Target,
			path: '/dashboard/quotas'
		},
		{
			id: 3,
			name: 'Audience',
			icon: Waypoints,
			path: '/dashboard/audience'
		},
		{
			id: 4,
			name: 'Responses',
			icon: MessageSquare,
			path: '/dashboard/responses'
		},
		{
			id: 5,
			name: 'Analytics',
			icon: LineChart,
			path: '/dashboard/analytics'
		},
		{
			id: 6,
			name: 'Agri data hub',
			icon: DatabaseZap,
			path: '/dashboard/agri-data-hub'
		}
	];

	const { user } = useAuth(); // Using your custom auth hook
	const location = useLocation(); // Replaces usePathname
	const [formList, setFormList] = useState([]);
	const [percFileCreated, setPercFileCreated] = useState(0);

	const path = location.pathname;
	const match = path.match(/^\/[^/]+(?:\/[^/]+)?/);

	const firstTwoSegments = match ? match[0] : "/";

	// This useEffect simulates fetching data once the user is available.
	// In a real app, you would fetch this from your API.
	useEffect(() => {
		if (user) {
			// --- MOCK DATA ---
			// Replace this with your actual API call.
			const mockFormList = [ { id: 1, name: 'Form A' }];
			setFormList(mockFormList);
			// --- END MOCK DATA ---
		}
	}, [user]);

	// This useEffect calculates the percentage whenever the form list changes.
	useEffect(() => {
		const totalForms = 3; // Max forms for a free plan
		const perc = (formList.length / totalForms) * 100;
		setPercFileCreated(perc);
	}, [formList]);

	return (
		<div className='h-screen shadow-md border'>
			<div className='p-5'>
				{menuList.map((menu, index) => (
					<Link
						to={menu.path}
						key={index}
						className={`flex items-center gap-3 p-4 mb-3
							hover:bg-primary hover:text-white rounded-lg
							cursor-pointer text-gray-500
							${firstTwoSegments === menu.path && 'bg-primary text-white'}
						`}
					>
						<menu.icon />
						{menu.name}
					</Link>
				))}
			</div>
			<div className='fixed bottom-7 p-6 w-64 '>
				<Button className="w-full">+ New survey</Button>
				<div className='my-7'>
					<Progress value={percFileCreated} />
					<h2 className='text-sm mt-2 text-gray-600'>
						<strong>{formList?.length || 0}</strong> Out of <strong>3</strong> File Created
					</h2>
					<h2 className='text-sm mt-3 text-gray-600'>Upgrade your plan for unlimited AI form build</h2>
				</div>
			</div>
		</div>
	);
}

export default SideNav;